"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _I18n = _interopRequireDefault(require("I18n"));

var _H = _interopRequireDefault(require("../elements/headings/H4"));

var _UIResultsMessage = _interopRequireDefault(require("../results/UIResultsMessage"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _illustrationName = require("../utils/propTypes/illustrationName");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var errorTypes = {
  badRequest: {
    image: 'errors/icecream',
    title: function title() {
      return _I18n.default.text('ui.UIErrorMessage.badRequest.title');
    }
  },
  error: {
    image: 'errors/icecream',
    title: function title() {
      return _I18n.default.text('ui.UIErrorMessage.error.title');
    }
  },
  expired: {
    image: 'errors/hourglass',
    title: function title() {
      return _I18n.default.text('ui.UIErrorMessage.expired.title');
    }
  },
  notFound: {
    image: 'errors/map',
    title: function title() {
      return _I18n.default.text('ui.UIErrorMessage.notFound.title');
    }
  }
};
var errors = (0, _extends2.default)({}, errorTypes, {
  '400': errorTypes.badRequest,
  '403': errorTypes.expired,
  '404': errorTypes.notFound,
  '500': errorTypes.error
});

var ErrorBody = function ErrorBody(props) {
  return _react.default.createElement(_UIResultsMessage.default.defaultProps.Body, (0, _extends2.default)({}, props, {
    className: "private-error-msg__body"
  }));
};

var ErrorImage = function ErrorImage(props) {
  return _react.default.createElement(_UIResultsMessage.default.defaultProps.Image, (0, _extends2.default)({}, props, {
    className: "private-error-msg__image"
  }));
};

var getErrorValues = function getErrorValues(type) {
  return errors[type] || errors.error;
};

var defaultIllustrationProps = {
  width: 175
};

var renderTitle = function renderTitle(title) {
  return _react.default.isValidElement(title) ? title : _react.default.createElement(_H.default, {
    className: "private-error-msg__title"
  }, (0, _lazyEval.default)(title));
};

var _default = _react.default.createClass({
  displayName: "UIErrorMessage",
  propTypes: {
    Body: _component.default,
    children: _react.PropTypes.node,
    illustration: (0, _illustrationName.getIllustrationNamePropType)(),
    illustrationProps: _react.PropTypes.object,
    title: (0, _createLazyPropType.default)(_react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.string])),
    type: _react.PropTypes.oneOf(Object.keys(errors))
  },
  getDefaultProps: function getDefaultProps() {
    return {
      Body: ErrorBody,
      illustrationProps: defaultIllustrationProps,
      type: 'error'
    };
  },
  render: function render() {
    var _this$props = this.props,
        Body = _this$props.Body,
        children = _this$props.children,
        className = _this$props.className,
        illustration = _this$props.illustration,
        illustrationProps = _this$props.illustrationProps,
        title = _this$props.title,
        type = _this$props.type,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["Body", "children", "className", "illustration", "illustrationProps", "title", "type"]);

    var _getErrorValues = getErrorValues(type),
        image = _getErrorValues.image,
        imageTitle = _getErrorValues.title;

    return _react.default.createElement(_UIResultsMessage.default, (0, _extends2.default)({}, rest, {
      Body: Body,
      className: (0, _classNames.default)('private-error-msg', className),
      illustration: illustration || image,
      illustrationProps: illustrationProps,
      Image: ErrorImage,
      title: renderTitle(title || imageTitle)
    }), children);
  }
});

exports.default = _default;
module.exports = exports.default;